import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoaderService {

  private _loadingCount: number = 0;
  private _loadingSubject = new BehaviorSubject<boolean>(false);

  constructor() {
  }

  get loading$(): Observable<boolean> {
    return this._loadingSubject.asObservable();
  }

  add() {
    this._loadingCount++;
    this.emitNext();
  }

  remove() {
    this._loadingCount--;
    this.emitNext();
  }

  private emitNext() {
    if (this._loadingCount < 0) {
      this._loadingSubject.error('Loading count less than 0');
    }
    this._loadingSubject.next(this._loadingCount > 0);
  }
}
